import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LuHistory } from 'react-icons/lu';
import AuthContext from '../../components/shared/AuthContext';
import PageMeta from '../../components/seo/PageMeta';
import BackNav from '../../components/navigation/BackNav';
import LearnPageShell from './LearnPageShell';
import { importKicker, importSubtitle } from '../../utils/importSourceLabels';
import './learn.css';

export default function LearnImportsPage() {
  const { apiClient, userProfile } = useContext(AuthContext);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await apiClient.get('/api/v1/learn/imports');
        setRows(Array.isArray(res.data) ? res.data : []);
      } catch {
        setRows([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [apiClient]);

  return (
    <>
      <PageMeta title="Import history" description="PDF, text, and URL import jobs" />
      <LearnPageShell userProfile={userProfile} loading={loading}>
        <BackNav to="/hub" label="Learn" />
        <section className="sh-block learn-imports-block">
          <header className="sh-block-head">
            <div className="sh-block-head-main">
              <span className="sh-block-icon" aria-hidden><LuHistory /></span>
              <div>
                <h1 className="sh-block-title">Import history</h1>
                <p className="sh-block-sub">PDF, pasted text, and URL imports across your notebooks</p>
              </div>
            </div>
          </header>
          {loading && <p className="learn-empty-line">Loading…</p>}
          {!loading && rows.length === 0 && (
            <p className="learn-muted">No imports yet. Open a notebook and import PDF, text, or a URL.</p>
          )}
          <div className="learn-nb-card-list">
            {rows.map((j) => (
              <div key={j.id} className="learn-import-row">
                <div className="learn-nb-card-body">
                  <h3 className="learn-nb-card-title">{j.notebookTitle || 'Notebook'}</h3>
                  <p className="learn-nb-card-meta learn-import-row-meta">
                    <span className="learn-import-type-badge">{importKicker(j)}</span>
                    <span className={`learn-import-badge learn-import-badge--${(j.status || '').toLowerCase()}`}>
                      {j.status}
                    </span>
                    <span>{j.questionsGenerated ?? 0} questions</span>
                  </p>
                  <p className="learn-muted learn-import-row-sub">{importSubtitle(j)}</p>
                </div>
                {j.notebookId && (
                  <Link to={`/hub/notebooks/${j.notebookId}`} className="home-btn home-btn-secondary learn-import-open">
                    Open
                  </Link>
                )}
              </div>
            ))}
          </div>
        </section>
      </LearnPageShell>
    </>
  );
}
